// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
// import { dispatch } from 'react-hot-toast/dist/core/store'

export const getAllData = createAsyncThunk('appTiposProcesos/getAllData', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Procesos`)
  return response.data.data
  // const data = []
  // return data
})

export const getData = createAsyncThunk('appTiposProcesos/getData', async param => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Procesos`, { params: param })
  return {
  param,
  data: response.data.data,
  totalPages: response.data.total}
})


export const getTipoProceso = createAsyncThunk('appTiposProcesos/getTipoProceso', async id => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Procesos/${id}`)
  return response.data.data
})

export const addTipoProceso = createAsyncThunk('appTiposProcesos/addTipoProceso', async (TipoProceso, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Procesos/crear`, TipoProceso)
  await dispatch(getData(getState().tiposProcesos.params))
  //await dispatch(getAllData())
  return response.data
})

export const deleteTipoProceso = createAsyncThunk('appTiposProcesos/deleteTipoProceso', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/Procesos/${id}`)
  await dispatch(getData(getState().tiposProcesos.params))
  //await dispatch(getAllData())
  return response.data
})

export const saveTipoProceso = createAsyncThunk('appTiposProcesos/saveTipoProceso', async (TipoProceso, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/Procesos`, TipoProceso)
  await dispatch(getData(getState().tiposProcesos.params))
  //await dispatch(getAllData())
  return response.data
})

export const downloadExcel = createAsyncThunk('appTiposProcesos/downloadExcel', async param => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Procesos/excel`, { params: param })
  return response
})

export const getTiposTransferencia = createAsyncThunk('appTiposProcesos/getTiposTransferencia', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias`)
  return response.data.data
})

export const getItemsGasto = createAsyncThunk('appTiposProcesos/getItemsGasto', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ItemsGasto`)
  return response.data.data
})

export const getTipoCuota = createAsyncThunk('appTiposCuotas/getTipoCuota', async id => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias/${id}`)
  return response.data.data
})

export const appTiposProcesosSlice = createSlice({
  name: 'appTiposProcesos',
  initialState: {
    data: [],
    total: '',
    params: {},
    allData: [],
    provincias: [],
    regiones: [],
    selectedTipoProceso: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.param
        state.total = action.payload.totalPages
      })
      .addCase(getTipoProceso.fulfilled, (state, action) => {
        state.selectedTipoProceso = action.payload
      })
  }
})

export default appTiposProcesosSlice.reducer
